<div class="background">

  <div class="login-panel">

    <img class="logo" [src]="settingsManagerService.getLogo(false)" alt="Scotty Expert">

    <ng-container *ngIf="!activatedRoute.snapshot.data.sso">

      <!-- Email -->
      <mat-form-field class="input" [color]="error ? 'warn' : 'primary'">
        <mat-label>Email</mat-label>
        <input matInput placeholder="Email" type="email" [disabled]="isLoggingIn" [(ngModel)]="email">
      </mat-form-field>

      <!-- Password -->
      <mat-form-field class="input" [color]="error ? 'warn' : 'primary'">
        <mat-label>Password</mat-label>
        <input matInput placeholder="Password" type="password" [disabled]="isLoggingIn" [(ngModel)]="password">
      </mat-form-field>

      <!-- Login-->
      <button *ngIf="!isLoggingIn" class="login-button" mat-raised-button color="primary" (click)="doLogin()" [disabled]="!isValidInput()">Login</button>

    </ng-container>

    <!-- Logging in spinner -->
    <mat-spinner *ngIf="isLoggingIn" class="spinner" [diameter]="30"></mat-spinner>

    <!-- Wrong credentials -->
    <span *ngIf="error" class="error">
      <mat-icon>close</mat-icon>
      {{ activatedRoute.snapshot.data.sso ? 'Error occurred during SSO login' : 'Wrong credentials. Try again.' }}
    </span>

  </div>

  <!-- by Wideverse -->
  <img *ngIf="environment.showByWideverseWatermark" class="byWideverse" src="assets/img/byWideverse.png" alt="Wideverse">

</div>
